<template>
  <div>
    <h1 class="ubuntu">
      Welcome to
      <span class="coreblue">Smart</span>
      <span class="corered">Marbles</span>.
    </h1>
    <p>This site is currently being redesigned. Thank you for your patience.</p>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String
  }
};
</script>
